import styled from "styled-components"

export const Container = styled.div`
    height: 100vh;
    scroll-snap-align: center;
    position: relative;
    overflow: hidden;
    align-content: flex-end;
    z-index: 0;
`
